import { useSelector } from 'react-redux';
import { companyOffersFreeShipping, productCompanyRuc } from '../../utils/shippingBehavior';

const useCompanyOffersFreeShipping = (product, companyRuc) => {
    const companiesByRuc = useSelector((state) => state.companies?.companiesByRuc || {});
    return companyOffersFreeShipping(companiesByRuc, companyRuc || productCompanyRuc(product));
};

export const FreeShippingBadge = ({ product, companyRuc = null, className = '' }) => {
    const offered = useCompanyOffersFreeShipping(product, companyRuc);
    if (!offered || product?.isFreeShippingApplicable !== true) {
        return null;
    }

    return (
        <span className={`product-free-shipping-badge ${className}`.trim()}>
            Envío gratis
        </span>
    );
};

export const ProductRowBenefitNotes = ({ product, companyRuc = null }) => {
    const offered = useCompanyOffersFreeShipping(product, companyRuc);
    const notes = [];
    if (offered && product?.isFreeShippingApplicable !== true) {
        notes.push('Genera costo de envío');
    }
    if (product?.isGlobalDiscountApplicable !== true) {
        notes.push('No aplica al descuento global');
    }

    if (notes.length === 0) {
        return null;
    }

    return <p className="product-benefit-notes">{notes.join(' · ')}</p>;
};
